const NETWORK_MESSAGE = 'Network Error';

const RESPONSE_HEADERS_FOR_DEBUG = [
  'x-request-id',
  'x-correlation-id',
  'cf-ray',
  'x-amzn-requestid',
  'retry-after',
  'content-type',
];

function pickResponseHeadersForDebug(headers) {
  if (!headers || typeof headers !== 'object') {
    return undefined;
  }
  const lower = {};
  for (const k of Object.keys(headers)) {
    lower[String(k).toLowerCase()] = headers[k];
  }
  const out = {};
  for (const key of RESPONSE_HEADERS_FOR_DEBUG) {
    const raw = lower[key];
    if (raw == null) continue;
    const v = typeof raw === 'string' ? raw : String(raw);
    out[key] = v.length > 500 ? v.slice(0, 500) + '\u2026' : v;
  }
  return Object.keys(out).length ? out : undefined;
}

function responseDataForMeta(data) {
  if (data === undefined) {
    return undefined;
  }
  if (Array.isArray(data)) {
    return { items: data };
  }
  if (data !== null && typeof data === 'object') {
    return data;
  }
  return { value: data };
}

export function buildAxiosErrorMeta(error, clientKey) {
  const capturedError = error instanceof Error ? error : new Error(String(error));
  const config = error.config;
  const status = error.response?.status;

  let errorName;
  if (status != null) {
    errorName = `STORE_API_ERROR_${status}`;
  } else if (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT') {
    errorName = 'STORE_API_ERROR_TIMEOUT';
  } else if (error.message === NETWORK_MESSAGE) {
    errorName = 'STORE_API_ERROR_NETWORK';
  } else {
    errorName = 'STORE_API_ERROR';
  }

  const meta = {};

  if (config) {
    const request = {
      client: clientKey,
      method: config.method,
      url: config.url,
      baseURL: config.baseURL,
    };
    if (config.meta?.requestStartedAt != null) {
      request.requestStartedAt = config.meta.requestStartedAt;
      request.durationMs = new Date().getTime() - config.meta.requestStartedAt;
    }
    if (config.timeout != null) {
      request.timeoutMs = config.timeout;
    }
    if (config.responseType != null) {
      request.responseType = config.responseType;
    }
    if (config.withCredentials === true) {
      request.withCredentials = true;
    }
    if (config.meta?.requestId) {
      request.requestId = config.meta.requestId;
    }
    meta.APIREQUEST = request;
  }

  if (typeof navigator !== 'undefined' && 'onLine' in navigator) {
    meta.APIRESPONSE = meta.APIRESPONSE || {};
    meta.APIRESPONSE.navigatorOnLine = navigator.onLine;
  }

  if (error.response) {
    const res = error.response;
    const apiResponse = {
      status: res.status,
      statusText: res.statusText,
    };
    const wrapped = responseDataForMeta(res.data);
    if (wrapped !== undefined) {
      apiResponse.data = wrapped;
    }
    const hdrs = pickResponseHeadersForDebug(res.headers);
    if (hdrs) {
      apiResponse.headers = hdrs;
    }
    meta.APIRESPONSE = { ...meta.APIRESPONSE, ...apiResponse };
  } else {
    meta.APIRESPONSE = {
      ...meta.APIRESPONSE,
      code: error.code,
      message: error.message,
    };
  }

  if (error.isAxiosError === true) {
    meta.APIRESPONSE = { ...meta.APIRESPONSE, isAxiosError: true };
  }

  return { meta, errorName, capturedError };
}
